import { createDefaultRoles } from 'garaje/mirage/helpers/roles';
/**
 * Sets up COVID-19 Test Result Scenario
 * - `MIRAGE_SCENARIO='covid19-test-result' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 * @returns {object} scenario models
 */
export default function covid19TestResultScenario(server) {
  const company =
    server.schema.companies.all().models[0] ||
    server.create('company', 'withConfig', 'withLocation', 'withBillingCompany', 'withGlobalAdmin', {
      name: 'Cool Chip',
    });

  const userDocumentTemplate =
    server.schema.userDocumentTemplates.findBy({ identifier: 'covid-19-test-result' }) ??
    server.create('user-document-template', 'asCovidTestResult');

  const location = company.locations.models[0];

  const userDocumentTemplateConfiguration = server.create('user-document-template-configuration', {
    userDocumentTemplate,
    active: true,
    userDocumentTemplateConfigurableId: { id: location.id, type: 'location' },
  });

  createDefaultRoles(server);

  return {
    company,
    location,
    userDocumentTemplate,
    userDocumentTemplateConfiguration,
  };
}
